import {useQueryClient} from '@tanstack/react-query';
import {useCallback} from 'react';

import {buyerKeys} from './useBuyersQuery';

/** Refetches the buyer page after one of its documents changes. */
export function useRefreshBuyerDetail(trustAccountId: string, buyerId: string): () => void {
  const queryClient = useQueryClient();

  return useCallback(() => {
    void queryClient.refetchQueries({
      queryKey: buyerKeys.detail(trustAccountId, buyerId),
      exact: true
    });
  }, [queryClient, trustAccountId, buyerId]);
}
